import { Component, OnInit } from '@angular/core';
import { ConnectRestService } from 'src/app/services/connect-rest.service'
import {Router, ActivatedRoute} from  '@angular/router';
import { EnglishTranslation, MalayTranslation, ProductCode } from '../app.constants';
import { UUID } from 'angular2-uuid';

declare var $: any;
@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OTPComponent implements OnInit {

  isLink = false;
  linkCaseID = null;
  linkSecuredCode = null;
  linkFlow = null;
  linkType = null;
  RetrieveData:boolean=false;
  OtpDelay:boolean=false;
  IsCorrectionRequired:boolean=false;
  OTPErrroMessage=null
  OTPResendTimer: number = 0;
  showErrorModal: boolean = false;
  disabled: boolean = false;
  textContent: any;
  langTranslation: string;
  captcha: any = 'assets/images/capcha-mock.png';
  captchaID: string = '';
  captchaNote: string = '';
  captchaError: boolean = false;
  modalMessage: string;
  ModalSMS: boolean = true;

  constructor(
    public router: Router, 
    private connect : ConnectRestService,
    private activeRoute : ActivatedRoute ) { 
      this.activeRoute.queryParams
        .subscribe(params =>
          { 
            this.linkCaseID = params["caseid"];
            this.linkFlow = params["flow"];
            this.linkSecuredCode = params["securecode"];
            this.linkType = params["type"];
            if (params["product"]) sessionStorage.setItem("currentProduct", params["product"]);
            
            if(params['lang'] && params['lang'] !== this.langTranslation) {
              this.textContent = params['lang'] == 'en-us' || params['lang'] == undefined ? EnglishTranslation.OTPScreen : MalayTranslation.OTPScreen;
              this.langTranslation = params['lang'];
              this.captchaNote = this.textContent.note1;
            }

            if(params['lang']) this.langTranslation = params['lang'];
        })

    if(this.linkCaseID!=undefined){
      this.isLink = true;
    }
    
  }

  onSubmit(){
    if($("#obaoform").valid()){
      this.validateOTP()
    }
  }
  
  async ngOnInit() {    
    this.langTranslation = sessionStorage.getItem("language") ? sessionStorage.getItem("language") : this.activeRoute.snapshot.queryParamMap.get('lang') ? this.activeRoute.snapshot.queryParamMap.get('lang'): "en-us";
    this.textContent = this.langTranslation == 'en-us' || this.langTranslation == undefined ? EnglishTranslation.OTPScreen : MalayTranslation.OTPScreen;
    this.modalMessage = this.textContent.modalError;
    this.captchaNote = this.textContent.note1;
    $(document).ready(() => {

      $("form").bind("keypress",function(e){
        if(e.keyCode == 13){
          return false;
        }
      })
      $("#obaoform").validate({
      rules: {
        otp_number: {
          required: true
        }
      },
      messages: {
  
        otp_number: {
          required: () => { return this.textContent.otpError },
          number: this.textContent.otpError2
        }

      },  errorPlacement:function(error,element){
      
      if(element.attr("name")=="otp_number"){
        error.appendTo($("#otp_number_error_container"));
      }
      },
      submitHandler: function (form) {
        // $("#btn-next").prop("disabled", true);
      }


    });



    });
    await this.linkOTPCode();
  }
  
  async linkOTPCode(){
     var CaseID = this.linkCaseID
     var ServiceHeader = {
       CaseID:CaseID,
       Flow:this.linkFlow,
       TokenID:null
     }
     sessionStorage.ServiceHeader = JSON.stringify(ServiceHeader)
     $('#btn-prv').addClass('hidden')
     await this.sendOTP()
  }

  async sendOTP(){
    $('.ErrorDisplayHTML').remove();
    const RequestID = "R0250"
    var responseData = await this.connect.connectRest({SecuredCode:this.linkSecuredCode,Language: this.activeRoute.snapshot.queryParamMap.get('lang') ? this.activeRoute.snapshot.queryParamMap.get('lang'): "en-us"}, RequestID, '')
    if(responseData.Status == "Success"){
      this.callSuccessFunction(responseData);      
      await this.getCaptcha(false);
    }else{
      // $('.obao-link').addClass('hidden')
      $('#btn-next').attr('disabled',true)
      if(responseData['errorMessage'] == "You have exceeded the maximum attempt to request SMS OTP, please try again later.") {
        this.modalMessage = this.textContent.modalError2;
        this.showErrorModal = true;
        this.disabled = true;
      }
    }

    var ServiceHeader = JSON.parse(sessionStorage.ServiceHeader);
    if (ServiceHeader.Flow == "2" || this.isLink){
      this.RetrieveData = true;
    }
  }  

  async getCaptcha(action) {

    var RequestID = "G0001";
    var uuid = sessionStorage.getItem('UUID') || UUID.UUID();
    var data = {get: true, uuid};
    if(action) {
      if(this.disabled) return;
      RequestID = "G0002"
      data['captchaId'] = this.captchaID;
      data['get'] = false;
    } 
    var temp = {
      "headers": { 'x-source-country' : 'MY',
      'x-source-id': 'MOBAO',
      'x-correlation-id' : uuid,
      'x-source-date-time' : new Date().toISOString() }
    }
    try{
      var responseData = await this.connect.connectRest(data, RequestID, temp);
      if(responseData.Status == "Success"){
        sessionStorage.setItem('UUID', uuid);
        $('.ErrorDisplayHTML').remove();
      }else{
        $('#btn-next').attr('disabled',true);
      }
      this.captcha = "data:image/png;base64," + responseData['data'].image;
      this.captchaID = responseData['data'].captchaId;
    } catch(ex){
      this.connect.displayErrorMessage(ex)
    }
  }

  callSuccessFunction(responseData) {
    if(responseData['AccountDetails'][0]['ProductCode'] !== sessionStorage.currentProduct) {
      this.router.navigate([], {
        relativeTo: this.activeRoute,
        queryParams: {
          product: responseData['AccountDetails'][0]['ProductCode']
        },
        queryParamsHandling: 'merge',
        skipLocationChange: false
      });
    }
    // save data to session storage and local storage
    sessionStorage.setItem("language", responseData['Language']);
    sessionStorage.setItem("currentProduct", responseData['AccountDetails'][0]['ProductCode']);
    localStorage.setItem("URLParam", JSON.stringify({"Product": responseData['AccountDetails'][0]['ProductCode'], ProductDescription: responseData['AccountDetails'][0]['ProductDescription']}));
    this.langTranslation = responseData['Language'] ?  responseData['Language'] : this.activeRoute.snapshot.queryParamMap.get('lang') ? this.activeRoute.snapshot.queryParamMap.get('lang') : "en-us";
    if(!this.activeRoute.snapshot.queryParamMap.get('lang')) {
      this.textContent = this.langTranslation == 'en-us' || this.langTranslation == undefined ? EnglishTranslation.OTPScreen : MalayTranslation.OTPScreen; 
      this.captchaNote = this.textContent.note1;
      this.router.navigate([], {
        relativeTo: this.activeRoute,
        queryParams: {
          lang: this.langTranslation
        },
        queryParamsHandling: 'merge',
        skipLocationChange: false
      });
    }
  }

  async validateOTP(){
    var RequestID = "R0252";
    var CaptchaDetails = {
      CaptchaID: this.captchaID,
      Value: $('#otp_number').val() 
    }
    var requestData = {CaptchaDetails, SecuredCode:null, Language: this.langTranslation}
    sessionStorage.setItem("RetrieveData", "true");
    sessionStorage.setItem("disableBack", "true");

    var responseData = await this.connect.connectRest(requestData, RequestID, '');

    if (responseData.Status=="Success"){
      sessionStorage.setItem("contactInfo", "false");
      var ServiceHeader = JSON.parse(sessionStorage.ServiceHeader);
      var lang = sessionStorage.getItem('language');

      // save d2 language if there is not any
      if (ServiceHeader.Flow == "2") {
        if(lang=="") {
          lang = this.activeRoute.snapshot.queryParamMap.get('lang');
          sessionStorage.setItem("language", lang);
          var RequestID2 = "R0321";
          await this.connect.connectRest({"Language": lang}, RequestID2, '');
        }
      }     

      var getRefResponse = await this.getRefData()
      if (getRefResponse==false){
        return false
      }
      if(this.isLink){         
        var urlparam = JSON.parse(localStorage.URLParam);
        urlparam.ProductDescription = lang == 'ms' && urlparam.Product == ProductCode.eBiz ? "Akaun OCBC eBiz" : lang == 'ms' && urlparam.Product == ProductCode.eBizi ? "Akaun OCBC eBiz-i" : urlparam.ProductDescription;
        localStorage.setItem("URLParam", JSON.stringify(urlparam));
        sessionStorage.setItem('ProductDescription', urlparam.ProductDescription);
        sessionStorage.constitution = responseData['CompanyTypeCode'];
        var ServiceHeader = JSON.parse(sessionStorage.ServiceHeader)
        var PageName = ServiceHeader.PageName.split(';')
        sessionStorage.setItem('resumePage', PageName);
        PageName = PageName[0]
        switch([this.linkFlow, this.linkType].join('')){
          //BBM assisted save and continue
          case '00':
            this.router.navigate(['/'+PageName]);
            break;
          //applicant save and continue
          case '10':
            this.router.navigate(['/'+PageName]);
            break;
          //applicant continue from BBM assested flow
          case '11':
            sessionStorage.setItem('resumePage', 'identify-your-company');
            this.router.navigate(['/identify-your-company']);
            break;
          //applicant error correction
          case '12':
            sessionStorage.setItem('resumePage', 'director-confirm');
            this.router.navigate(['/director-confirm']);
            break;
          //reviewer continue from applicant flow
          case '20':
            if(this.IsCorrectionRequired){
              sessionStorage.setItem('resumePage', 'director-confirm');
              this.router.navigate(['/director-confirm']);
            }else{
              sessionStorage.setItem('resumePage', 'signature');
              this.router.navigate(['/signature']);
            }
            break;
          //reviewer save and continue
          case '22':
            this.router.navigate(['/'+PageName]);
            break;
        }
      }else{
        this.router.navigate(['/identify-your-company']);
      }
    }else{
      this.hadleErrorCaptchError(responseData['ServiceMessage']);
    }
  }  

  hadleErrorCaptchError(e) {
    if(e.ErrorCode == 'EC092')  {
      this.captchaNote = e.ErrorDescription;
      this.captchaError = true;
    } else if (e.ErrorCode == 'EC093') {
      this.modalMessage = e.ErrorDescription;
      this.ModalSMS = false;
      this.showErrorModal = true;
      this.disabled = true;
    }
  }  

  goTOLandingPage() {
    this.showErrorModal = false;
  }

  async getRefData(){
    var responseData = await this.connect.connectRest({Keys:[{Code:"ALL"}], Language: sessionStorage.language},"R0300","")
    if(responseData.Status == "Success"){
      var RefCODL=[]
      var RefBPDL=[]
      var RefSCDL=[]
      var RefCCDL=[]
      var RefPADL=[]
      var RefNTDL=[]
      var RefETDL=[]
      var RefET=[]
      var RefDWDL=[]
      var RefPPDL=[]
      var RefDWC = []
      var RefRACE = []

      RefCODL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="CODL"
      }))

      RefBPDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="BPDL"
      }))

      RefSCDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="SCDL"
      }))

      RefCCDL.push(responseData['RefDetails'].filter(function(obj){
        return (obj.ID =="CCDL" && obj.Code != "ZZ")
      }))

      RefPADL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="PADL"
      }))

      RefNTDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="NTDL"
      }))

      RefETDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="ETDL"
      }))

      RefET.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID == "PTDL"
      }))

      RefDWDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID == "DWDL"
      }))

      RefPPDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID == "PPDL"
      }))

      RefDWC.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID == "DWC"
      }))

      RefRACE.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID == "Race"
      }))

      sessionStorage.RefCODL = JSON.stringify(RefCODL[0])
      sessionStorage.RefBPDL = JSON.stringify(RefBPDL[0])
      sessionStorage.RefSCDL = JSON.stringify(RefSCDL[0])
      sessionStorage.RefCCDL = JSON.stringify(RefCCDL[0])
      sessionStorage.RefPADL = JSON.stringify(RefPADL[0])
      sessionStorage.RefNTDL = JSON.stringify(RefNTDL[0])
      sessionStorage.RefETDL = JSON.stringify(RefETDL[0])
      sessionStorage.RefET = JSON.stringify(RefET[0])
      sessionStorage.RefDWDL = JSON.stringify(RefDWDL[0])
      sessionStorage.RefPPDL = JSON.stringify(RefPPDL[0])
      sessionStorage.RefDWC = JSON.stringify(RefDWC[0])
      sessionStorage.RefRACE = JSON.stringify(RefRACE[0])
      return true
    }else{
      $('.obao-link').addClass('hidden')
      $('#btn-next').attr('disabled',true)
      $('#otp_number').attr('disabled',true)
      return false
    }
  }
}
